export default function CircularProgress({
  size = 40,
  thickness = 4,
}) {
  return (
    <div
      style={{
        width: size,
        height: size,
        border: `${thickness}px solid rgba(255,255,255,0.2)`,
        borderTop: `${thickness}px solid currentColor`,
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
      }}
    />
  );
}